import type { ActivityMessage } from "@/api/models"

import { ActivityMessageHistory } from "@/features/chat/components/activity-message/activity-message-history"

const SAMPLE_MESSAGES: ActivityMessage[] = [
  {
    type: "activity",
    activity_type: "web_search_started",
    message: "web_search_started",
    timestamp: Date.now() - 4000,
  },
  {
    type: "activity",
    activity_type: "web_search_results",
    message: "web_search_results_found",
    details: {
      translation_key: "web_search_results_found",
      results: [
        {
          title: "AI and Machine Learning in 2024: Latest Trends",
          url: "https://techcrunch.com/ai-ml-trends-2024",
        },
        {
          title: "How Companies Are Using AI to Transform Business",
          url: "https://hbr.org/companies-using-ai-business",
        },
        {
          title: "The Future of Artificial Intelligence in Enterprise",
          url: "https://forbes.com/future-ai-enterprise",
        },
      ],
      count: 3,
    },
    timestamp: Date.now() - 3000,
  },
  {
    type: "activity",
    activity_type: "library_search_started",
    message: "library_search_started",
    timestamp: Date.now() - 2000,
  },
  {
    type: "activity",
    activity_type: "search_results",
    message: "search_results",
    details: {
      translation_key: "navigator_search_completed_singular",
      results: [
        { title: "Q4 Financial Report 2024.pdf", library: "Finansrapporter" },
        { title: "Annual Strategy Document.docx", library: "Strategi" },
        { title: "Product Roadmap Overview.pptx", library: "Produktutveckling" },
        { title: "Market Analysis Report.pdf", library: "Marknadsanalys" },
      ],
      count: 4,
    },
    timestamp: Date.now() - 1000,
  },
  {
    type: "activity",
    activity_type: "file_search_started",
    message: "file_search_started",
    timestamp: Date.now() - 500,
  },
  {
    type: "activity",
    activity_type: "code_interpreter_started",
    message: "code_interpreter_started",
    timestamp: Date.now(),
  },
]

export function DemoActivityMessages() {
  return (
    <div className="w-full sm:max-w-2xl">
      <ActivityMessageHistory demoMode isDefaultOpen messages={SAMPLE_MESSAGES} />
    </div>
  )
}
